export default __webpack_public_path__ + "static/liviu-57b477a9d4c1fa7194334ab8de4bc18e.svg";